function createShareUrl({ title, text, url }) {
  if (title) text = title + ' - ' + text
  return `https://www.facebook.com/sharer/sharer.php?quote=${text}&u=${url}`
}
/*
 * TODO: the icon has the name 'fb-msg' and is the key
 *       However in the KWK Services this is named 'messenger'
 * FIXME: Rename the icon 'messenger'
 */
export default {
  id: 'messenger',
  title: 'Messenger',
  createShareUrl
}
